import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { DMV_RECORDS_PURGE_URL, DOG_TAGS_PURGE_URL, FARM_APPLICATIONS_PURGE_URL, MAINTENANCE_COUNTS_URL, TAXPAYERS_PURGE_URL, UPD_THEME_URL, UPD_TIMEOUT_URL } from "./Constants.js"
import ErrorPopup from "./ErrorPopup.js"
import StatusPopup from "./StatusPopup.js"

const Configure = () => {
	const [selectedOption, setSelectedOption] = useState("")
	const [error, setError] = useState("")
	const [status, setStatus] = useState("")
	const [themeStatus, setThemeStatus] = useState("")

	const Theme = useStoreState((state) => state.Theme)
	const setTheme = useStoreActions((actions) => actions.setTheme)
	const Token = useStoreState((state) => state.Token)
	const setToken = useStoreActions((actions) => actions.setToken)
	const [timeoutInput, setTimeoutInput] = useState(Token.timeout)
	const [showTimeoutHelp, setShowTimeoutHelp] = useState(false)

	// Maintenance (retention purge) — only for users with User-module access
	const AuthUser = useStoreState((state) => state.AuthUser)
	const [maint, setMaint] = useState(null)
	const [maintStatus, setMaintStatus] = useState("")
	const [maintError, setMaintError] = useState("")
	const [confirmTarget, setConfirmTarget] = useState(null)
	const [purging, setPurging] = useState(false)
	let T = -1

	useEffect(() => {
		switch (Theme) {
			case 0:
				setSelectedOption("lightblue")
				break
			case 1:
				setSelectedOption("darkblue")
				break
			case 2:
				setSelectedOption("lightgreen")
				break
			case 3:
				setSelectedOption("darkgreen")
				break
			case 4:
				setSelectedOption("white")
				break
			case 5:
				setSelectedOption("black")
				break
			default:
				break
		}
	}, [])

	const handleOptionChange = (e) => {
		if (e.target.value === "lightblue") {
			// light blue
			setTheme(0)
			setSelectedOption("lightblue")
			T = 0
		} else if (e.target.value === "darkblue") {
			// dark blue
			setTheme(1)
			setSelectedOption("darkblue")
			T = 1
		} else if (e.target.value === "lightgreen") {
			// light green
			setTheme(2)
			setSelectedOption("lightgreen")
			T = 2
		} else if (e.target.value === "darkgreen") {
			// dark green
			setTheme(3)
			setSelectedOption("darkgreen")
			T = 3
		} else if (e.target.value === "white") {
			setTheme(4)
			setSelectedOption("white")
			T = 4
		} else if (e.target.value === "black") {
			setTheme(5)
			setSelectedOption("black")
			T = 5
		}
		updTheme()
	}

	const updTheme = async () => {
		try {
			const theme_data = {
				userid: Token.login_id,
				client_id: Token.client_id,
				theme: T,
			}
			const { data } = await axios.put(UPD_THEME_URL, theme_data)
			setThemeStatus("success")
			setError("")
		} catch (err) {
			setError(err.message)
		}
		setTimeout(() => {
			// remove the message line
			setThemeStatus("")
		}, 3000)
	}
	const handleTimeOutChange = (e) => {
		if (/^\d*$/.test(e.target.value)) setTimeoutInput(e.target.value)
	}

	const handleTimeOutKeyDown = (e) => {
		if (e.key === "F1") { e.preventDefault(); setShowTimeoutHelp(true); return }
		if (e.key === "Enter") e.target.blur()
	}

	const handleTimeOutBlur = async () => {
		const clamped = Math.min(60, Math.max(5, parseInt(timeoutInput) || 60))
		setTimeoutInput(clamped)
		try {
			await axios.post(UPD_TIMEOUT_URL, {
				userid: Token.login_id,
				client_id: Token.client_id,
				timeout: clamped,
			})
			setToken({ ...Token, timeout: clamped })
			setStatus("success")
			setError("")
		} catch (err) {
			setError(err.message)
		}
		setTimeout(() => setStatus(""), 3000)
	}

	async function loadMaintCounts() {
		const { data } = await axios.post(MAINTENANCE_COUNTS_URL, {
			login_id: Token.login_id,
			client_id: Token.client_id,
		})
		setMaint(data)
	}

	useEffect(() => {
		if (!AuthUser) return
		loadMaintCounts().catch((err) => setMaintError(err.message))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [AuthUser, Token.login_id, Token.client_id])

	async function handlePurge(target) {
		setPurging(true)
		setMaintError("")
		const url =
			target === "farm" ? FARM_APPLICATIONS_PURGE_URL
			: target === "dmv" ? DMV_RECORDS_PURGE_URL
			: target === "taxpayers" ? TAXPAYERS_PURGE_URL
			: DOG_TAGS_PURGE_URL
		try {
			await axios.post(url, { login_id: Token.login_id, client_id: Token.client_id })
			await loadMaintCounts()
			setMaintStatus(`${target}-success`)
			setTimeout(() => setMaintStatus(""), 3000)
		} catch (err) {
			setMaintError(err.response?.data?.detail || err.message)
		} finally {
			setPurging(false)
			setConfirmTarget(null)
		}
	}

	return (
		<main className="Main">
			<fieldset className="chooseTheme">
				<legend>Choose Theme</legend>
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="lightblue"
						checked={selectedOption === "lightblue"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; Light Grey Blue
				</label>
				<br />
				<br />
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="darkblue"
						checked={selectedOption === "darkblue"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; Dark Grey Blue
				</label>
				<br />
				<br />
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="lightgreen"
						checked={selectedOption === "lightgreen"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; Light Green
				</label>
				<br />
				<br />
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="darkgreen"
						checked={selectedOption === "darkgreen"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; Dark Green
				</label>
				<br />
				<br />
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="white"
						checked={selectedOption === "white"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; White
				</label>
				<br />
				<br />
				<label>
					<input
						type="radio"
						name="theme-radio"
						value="black"
						checked={selectedOption === "black"}
						onChange={(e) => handleOptionChange(e)}
					/>
					&nbsp;&nbsp; Black
				</label>
				<br />
				{themeStatus === "success" && <StatusPopup message="Theme updated successfully." />}
			</fieldset>

			<fieldset className="chooseTheme">
				<legend>Global Idle Timeout</legend>
				<label id="TimeoutLbl">Timeout in minutes:</label>
				<input
					id="timeout"
					type="text"
					name="resettimeout"
					className="f1-input"
					value={timeoutInput}
					onChange={(e) => handleTimeOutChange(e)}
					onKeyDown={(e) => handleTimeOutKeyDown(e)}
					onBlur={handleTimeOutBlur}
					onFocus={(e) => e.target.select()}
				/>
				{status === "success" && <StatusPopup message="Timeout updated successfully." />}
			</fieldset>

			{AuthUser && (
				<fieldset className="chooseTheme">
					<legend>Maintenance</legend>
					<p style={{ marginTop: 0, lineHeight: 1.5 }}>
						Permanently remove old records. These actions cannot be undone.
					</p>
					<div style={{ marginBottom: "0.75rem" }}>
						<span style={{ marginRight: "1rem" }}>
							Farm applications before {maint ? maint.cutoff_year : "—"}: <strong>{maint ? maint.farm_apps : "—"}</strong>
						</span>
						<button
							className="saveBtn"
							type="button"
							disabled={!maint || maint.farm_apps === 0 || purging}
							onClick={() => setConfirmTarget("farm")}
						>
							Delete Old Farm Applications
						</button>
						{maintStatus === "farm-success" && <StatusPopup message="Old farm applications deleted." />}
					</div>
					<div style={{ marginBottom: "0.75rem" }}>
						<span style={{ marginRight: "1rem" }}>
							DMV records before {maint ? maint.cutoff_year : "—"}: <strong>{maint ? maint.dmv_records : "—"}</strong>
						</span>
						<button
							className="saveBtn"
							type="button"
							disabled={!maint || maint.dmv_records === 0 || purging}
							onClick={() => setConfirmTarget("dmv")}
						>
							Delete Old DMV Records
						</button>
						{maintStatus === "dmv-success" && <StatusPopup message="Old DMV records deleted." />}
					</div>
					<div>
						<span style={{ marginRight: "1rem" }}>
							Unused dog tags before fiscal year {maint ? maint.tag_fiscal_year : "—"}: <strong>{maint ? maint.old_tags : "—"}</strong>
						</span>
						<button
							className="saveBtn"
							type="button"
							disabled={!maint || maint.old_tags === 0 || purging}
							onClick={() => setConfirmTarget("tags")}
						>
							Delete Unused Prior-Year Tags
						</button>
						{maintStatus === "tags-success" && <StatusPopup message="Unused prior-year tags deleted." />}
					</div>
					<div style={{ marginTop: "0.75rem" }}>
						<span style={{ marginRight: "1rem" }}>
							Taxpayers with no activity since {maint ? maint.cutoff_year : "—"}: <strong>{maint ? maint.taxpayers : "—"}</strong>
							{maint && maint.taxpayers > 0 && (
								<> (plus {maint.taxpayer_child_rows} related record(s))</>
							)}
						</span>
						<button
							className="saveBtn"
							type="button"
							disabled={!maint || maint.taxpayers === 0 || purging}
							onClick={() => setConfirmTarget("taxpayers")}
						>
							Delete Inactive Taxpayers
						</button>
						{maintStatus === "taxpayers-success" && <StatusPopup message="Inactive taxpayers deleted." />}
					</div>
					<ErrorPopup message={maintError} onClose={() => setMaintError("")} />
				</fieldset>
			)}

			{confirmTarget && maint && (
				<div
					style={{
						position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)", zIndex: 1000,
						display: "flex", alignItems: "center", justifyContent: "center",
					}}
					onClick={() => { if (!purging) setConfirmTarget(null) }}
				>
					<div
						style={{
							background: "#fff", border: "1px solid #888",
							borderRadius: "6px", padding: "1.5rem 2rem", maxWidth: "480px",
							width: "90%", boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3 style={{ marginTop: 0, marginBottom: "1rem", color: "rgb(60, 60, 60)" }}>Confirm Deletion</h3>
						<p style={{ lineHeight: 1.6 }}>
							Permanently delete{" "}
							<strong>
								{confirmTarget === "farm"
									? `${maint.farm_apps} farm application(s)`
									: confirmTarget === "dmv"
									? `${maint.dmv_records} DMV record(s)`
									: confirmTarget === "taxpayers"
									? `${maint.taxpayers} taxpayer(s) and ${maint.taxpayer_child_rows} related record(s) — dogs, tags, transactions, sheep & goats, kennels`
									: `${maint.old_tags} unused dog tag(s)`}
							</strong>{" "}
							from before {confirmTarget === "tags" ? `fiscal year ${maint.tag_fiscal_year}` : maint.cutoff_year}? This cannot be undone.
						</p>
						<div style={{ textAlign: "right", marginTop: "1.25rem" }}>
							<button
								className="saveBtn"
								type="button"
								disabled={purging}
								style={{ marginRight: "0.75rem" }}
								onClick={() => setConfirmTarget(null)}
							>
								Cancel
							</button>
							<button
								className="saveBtn"
								type="button"
								disabled={purging}
								style={{ backgroundColor: "#c0392b", color: "white" }}
								onClick={() => handlePurge(confirmTarget)}
							>
								{purging ? "Deleting…" : "Delete"}
							</button>
						</div>
					</div>
				</div>
			)}

			{showTimeoutHelp && (
				<div
					style={{
						position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
						backgroundColor: "rgba(0,0,0,0.45)", zIndex: 1000,
						display: "flex", alignItems: "center", justifyContent: "center",
					}}
					onClick={() => setShowTimeoutHelp(false)}
				>
					<div
						style={{
							background: "#fff", border: "1px solid #888",
							borderRadius: "6px", padding: "1.5rem 2rem", maxWidth: "520px",
							width: "90%", boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
							color: "rgb(100, 100, 100)",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<h3 style={{ marginTop: 0, marginBottom: "1rem", color: "rgb(60, 60, 60)" }}>Configure — Help</h3>
						<p style={{ marginBottom: "0.5rem", fontWeight: "bold", lineHeight: "1.6" }}>Theme</p>
						<ul style={{ marginBottom: "1rem", paddingLeft: "1.25rem", lineHeight: "1.6" }}>
							<li style={{ marginBottom: "0.4rem" }}>Select a radio button to apply a new theme. The change takes effect <strong>immediately</strong> — there is no save button.</li>
							<li>The theme is personal to your login account and does not affect other users.</li>
						</ul>
						<p style={{ marginBottom: "0.5rem", fontWeight: "bold", lineHeight: "1.6" }}>Idle Timeout</p>
						<ul style={{ marginBottom: "1rem", paddingLeft: "1.25rem", lineHeight: "1.6" }}>
							<li style={{ marginBottom: "0.4rem" }}>The idle timeout is a <strong>global setting</strong> — it applies to every user in the system, not just your own session.</li>
							<li style={{ marginBottom: "0.4rem" }}>Enter the number of <strong>minutes</strong> of inactivity before a user is automatically logged out. Allowed range: 5 – 60 minutes.</li>
							<li style={{ marginBottom: "0.4rem" }}>Press <strong>Tab</strong> or <strong>Enter</strong> to save the new value. The change applies to all users immediately.</li>
							<li style={{ marginBottom: "0.4rem" }}><strong>Any activity resets the timer</strong> — keystrokes, mouse movement, and mouse clicks all count. The countdown only advances during genuine inactivity.</li>
							<li>When the timer expires the user is logged out immediately and returned to the Login page. Any unsaved work will be lost.</li>
						</ul>
						<div style={{ textAlign: "center" }}>
							<button className="taxpayer-saveBtn" type="button" onClick={() => setShowTimeoutHelp(false)}>
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</main>
	)
}

export default Configure
